import * as React from 'react';

import EmailVerification140 from './EmailVerification140';

export const emailVerification140 = () => <EmailVerification140 />;

export default {
    title: 'Illustration/EmailVerification140',
    component: EmailVerification140,
    parameters: {
        notes: "`import EmailVerification140 from 'box-ui-elements/es/illustration/EmailVerification140';`",
    },
};
